import type { MBDAttributes } from '@shared/types/frontend/meaningful-behaviour-data';

import {
  MBD_ITEMS,
  MBD_TYPE,
} from '@shared/constants/meaningful-behaviour-data';
import generateTrackingAttributes from '@shared/utils-frontend/meaningful-behaviour-data/generate-tracking-attributes';

export const buildOfferFiltersMBDAttributes = (
  optionKey: string,
): MBDAttributes => {
  const { id, name } = MBD_ITEMS[MBD_TYPE.HOTEL_OFFER_FILTERS];
  /* MDB has a limit of 40 for strings params;
     Some option key length exceed 40,
     so we trim the starting part of the key because the ending part is more meaningful. */
  return generateTrackingAttributes(`${id}_${optionKey}`, name, {
    option:
      optionKey.length <= 40
        ? optionKey
        : optionKey.substring(optionKey.length - 40),
  });
};
